import r from "../../shared-lib/braze-shared-lib.js";
export default class _t {
  constructor(t, e, s) {
    null == t && (t = r.it.nt()),
      (s = parseInt(s)),
      (isNaN(s) || 0 === s) && (s = new Date().valueOf()),
      (this.iu = t),
      (this.jh = s),
      (this.Wh = new Date().valueOf()),
      (this.Hh = e);
  }
  ss() {
    return { g: this.iu, e: this.Hh, c: this.jh, l: this.Wh };
  }
  static Pn(t) {
    if (null == t || null == t.g) return null;
    const e = new _t(t.g, t.e, t.c);
    return (e.Wh = t.l), e;
  }
}
